import { Component, AfterViewInit,ElementRef,Renderer2, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { TableColumn } from '../models/table-column.model';
import { DataType } from '../enums/data-type.enum';
import { Table } from 'primeng/table';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ToastMessageSeverity } from 'src/app/enums/ToastMessageSeverity.enum';
import { MatrisToastService } from '../matris-toast.service';
import { environment } from 'src/environments/environment'; // adjust path to match your project structure
import { SOURCING_STRATEGY_ITEMS, BRAND_REGION_MAP } from 'src/app/matrisneocommon/models/sourcing-strategy.items';
@Component({
  selector: 'neo-matris-table',
  templateUrl: './matris-table.component.html',
  styleUrls: ['./matris-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MatrisTableComponent implements OnInit {
    @ViewChild('dt1') dt1: Table;
  @Input() stateKey: string = '';
  @Input() rows: any[] = []
  @Input() columns: TableColumn[] = []
  @Input() showLoadingColumn: boolean = false;
  @Input() tableHeader: string = ''
  @Input() isGroupHeader: boolean = false;
  @Input() totalRecords: number = 0
  @Input() loading: boolean = false;
  @Input() isFooterVisible = false;
  @Input() placeholder: string = ''
  @Input() showCaption: boolean = true;
  @Input() selectionMode: 'single' | 'multiple' | '' = 'multiple'; 
  @Input() isInvoiceRadioButton: boolean = false;

  sortField: string = '';
  @Input() selectedRow: any;
  @Output() pageChange = new EventEmitter<any>()
  @Output() rowSelect = new EventEmitter<any>()
  @Output() rowUnselect = new EventEmitter<any>()
  @Output() tableDropdownChange = new EventEmitter<any>()
  @Output() historyData = new EventEmitter<any>()
  @Output() tableSearchButtonClick = new EventEmitter<any>()
  @Output() tableDateChange = new EventEmitter<any>()
  @Output() tableInputChange = new EventEmitter<any>()
  @Output() blurChange = new EventEmitter<any>()
  @Output() onKeydown = new EventEmitter<any>()
  @Output() deleteTableItem = new EventEmitter<any>()
  @Input() rowLevelEdit: boolean = false
  @Input() columnLevelEdit: boolean = !this.rowLevelEdit
  @Input() showPaginator: boolean = false;
  @Input() disableTable: boolean = false;
  @Input() showEmptyMessage: boolean = false;
  @Input() showTableSkeleton: boolean = false;
  @Input() skeletonRows: any = 20;
  @Input() showTable: boolean = true;
  @Input() reorderColumns: boolean = false;
  @Input() editTable: boolean = false;
  @Input() lockTable: boolean = false;
  @Input() lockTableForAddTeamMember: boolean = false;
  rowsCount: number = 10
  @Input() isTableBorderDisabled: boolean = false;
  @Output() addTeamMember = new EventEmitter<{ rowData: any, field: string, rowIndex: any }>();
  @Output() editMember = new EventEmitter<{ rowData: any, item: string; rowIndex: number; field: string }>();
  bindDate: any;
  @Input() first: number = 0
  collection = [1, 2, 3, 4, 5, 6, 7, 8, 9]
  sizes!: any[];
  selectedRowForSingleSelection: any = null;
  selectedRowForMultipleSelection: any[] = [];
  @ViewChild('calendarOverlay') calendarOverlay: OverlayPanel;
  @Input() showColumns: boolean = true;
  @Input() starredState: any;
  @Input() isTeamNew: boolean = false;
  @Output() dropdownFilterChange = new EventEmitter<{ event: any }>();
  @Output() sortStatus: EventEmitter<{ field: string, order: string }> = new EventEmitter();
  @Output() radioSelect = new EventEmitter<{ field: any, rowData: any }>();
  @Output() checkboxChange = new EventEmitter<{ event: any, field: string, rowData: any }>();
  @Output() viewRow = new EventEmitter<any>();
  @Input() selectedRowIA: any;
  @Input() selectedRowSASMA: any[] = [];
  checkboxField: string;
  @Input() enableRowClick: boolean = true;
  @Input() enableRowSelectionStyle: boolean = true;
  @Input() separateRowAndCheckboxClick: boolean = false;
  @Output() sourcingProjectClick = new EventEmitter<any>();
  @Output() historyClicked = new EventEmitter<any>();
  @Output() noteEnter = new EventEmitter<any>();
  @Output() copyOrderClick = new EventEmitter<any>();
  @Output() columnWidthsChange = new EventEmitter<{ [field: string]: number }>();
  selectAllChecked: boolean = false;
  @Output() selectAllChange = new EventEmitter<{ checked: boolean, rows: any[] }>();

   constructor(private toastService: MatrisToastService, private renderer: Renderer2) { }
   @Output() columnOrderChange = new EventEmitter<TableColumn[]>();
   sortState: { [key: string]: number } = {};
   @Input() set initialSort(value: { field: string; order: number } | null) {
  this.sortState = value && value.field ? { [value.field]: value.order } : {};
}
  private currentEnv: string = environment.production ? 'PROD' : 'DEV';

 ngOnInit() {

    if (!this.isTeamNew) {
      this.initializeStarStateFromInput();
    }
    if (this.selectedRowIA) {
      this.selectedRowForSingleSelection = this.selectedRowIA;
    }
    if (this.selectedRowSASMA) {
      this.selectedRowForMultipleSelection = this.selectedRowSASMA;

    }

    const checkboxColumn = this.columns.find(col => col.columnType === 15);
    this.checkboxField = checkboxColumn ? checkboxColumn.field : 'isSelected';

    this.loadColumnWidths();
    this.loadColumnOrder();
    this.updateSelectAllState(); 

  }

  ngAfterViewInit(): void {
    this.applyStoredColumnWidths();
  }

  private applyColumnWidthsToDom(): void {
    if (!this.dt1) return;

    const colElements = (this.dt1.el.nativeElement as HTMLElement).querySelectorAll('colgroup col');
    if (!colElements.length) return;

    this.columns.forEach((col, index) => {
      if (col.width && colElements[index]) {
        this.renderer.setStyle(colElements[index], 'width', `${col.width}px`);
      }
    });
  }

  onColumnResize(event: any): void {
    const thElement = event.element as HTMLElement;
    if (!thElement?.parentElement) return;

    const ths = Array.from(thElement.parentElement.children) as HTMLElement[];
    const index = ths.indexOf(thElement);
    if (index === -1 || index >= this.columns.length) return;

    this.columns[index].width = thElement.offsetWidth;

    const widths: { [field: string]: number } = {};
    this.columns.forEach(col => {
      if (col.width) {
        widths[col.field] = col.width;
      }
    });
    this.columnWidthsChange.emit(widths);
  }
  private getColumnWidthStorageKey(): string {
    return `neo-matris-table-col-widths-${this.stateKey}`;
  }

  loadColumnWidths(): void {
    if (!this.stateKey || !this.columns?.length) return;

    try {
      const saved = localStorage.getItem(this.getColumnWidthStorageKey());
      if (!saved) return;

      const widths: { [field: string]: number } = JSON.parse(saved);
      this.columns.forEach(col => {
        if (widths[col.field] != null) {
          col.width = widths[col.field];
        }
      });
    } catch (e) {
      console.error('Failed to load column widths from localStorage:', e);
    }
  }

  private applyStoredColumnWidths(): void {
    if (!this.stateKey || !this.dt1) return;

    const colElements = (this.dt1.el.nativeElement as HTMLElement).querySelectorAll('colgroup col');
    if (!colElements.length) return;

    this.columns.forEach((col, index) => {
      if (col.width && colElements[index]) {
        this.renderer.setStyle(colElements[index], 'width', `${col.width}px`);
      }
    });
  }

  getCellStyle(rowData: any, col: any): any {
    return {
      display: col.display,
      ...(col.style || {}),
      ...(rowData?.[col.field + '_STYLE'] || {})
    };
  }

  getRowStyle(rowData: any): any {
    return rowData.ROW_STYLE || null;
  }

  getDropdownDisplayName(rowData: any, field: string): string {
    const dropdown = rowData[field + 'Dropdown'];
    if (!dropdown || !Array.isArray(dropdown)) return rowData[field];
    const match = dropdown.find(o => o.code === rowData[field]);
    return match ? match.name : rowData[field];
  }

  saveColumnWidths(): void {
    if (!this.stateKey) return;

    const widths: { [field: string]: number } = {};
    this.columns.forEach(col => {
      if (col.width) {
        widths[col.field] = col.width;
      }
    });

    try {
      localStorage.setItem(this.getColumnWidthStorageKey(), JSON.stringify(widths));
    } catch (e) {
      console.error('Failed to save column widths to localStorage:', e);
    }
  }

private getColumnOrderStorageKey(): string {
    return `neo-matris-table-col-order-${this.currentEnv}-${this.stateKey}`;
  }

  loadColumnOrder(): void {
    if (!this.stateKey || !this.columns?.length) return;

    try {
      const saved = localStorage.getItem(this.getColumnOrderStorageKey());
       
      if (!saved) return;

      const savedOrder: string[] = JSON.parse(saved);
      const byField = new Map(this.columns.map(col => [col.field, col]));
      const reordered = savedOrder
        .map(field => byField.get(field))
        .filter((col): col is TableColumn => !!col);

      this.columns.forEach(col => {
        if (!savedOrder.includes(col.field)) {
          reordered.push(col);
        }
      });

      this.columns = reordered;
    } catch (e) {
      console.error('Failed to load column order from localStorage:', e);
    }
  }

  saveColumnOrder(): void {
    if (!this.stateKey) return;

    const order = this.columns.map(col => col.field);

    try {
      localStorage.setItem(this.getColumnOrderStorageKey(), JSON.stringify(order));
    } catch (e) {
      console.error('Failed to save column order to localStorage:', e);
    }
  }

  onColReorder(event: { dragIndex: number; dropIndex: number }): void {
    const { dragIndex, dropIndex } = event;
    const reordered = [...this.columns];
    const [moved] = reordered.splice(dragIndex, 1);
    reordered.splice(dropIndex, 0, moved);
    this.columns = reordered;

    this.saveColumnOrder();
    this.columnOrderChange.emit(this.columns);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['starredState'] && !this.isTeamNew) {
      this.initializeStarStateFromInput();
    }
    if (this.selectedRowIA) {
      this.selectedRowForSingleSelection = this.selectedRowIA;
    }
    if (this.selectedRowSASMA) {
      this.selectedRowForMultipleSelection = this.selectedRowSASMA;
     
    }

    if (changes['rows'] || changes['columns']) {
      const checkboxColumn = this.columns.find(col => col.columnType === 15);
      this.checkboxField = checkboxColumn ? checkboxColumn.field : this.checkboxField;
      this.updateSelectAllState();
    }
  }
enforceMaxLength(event: Event, maxLength?: number): void {
  if (!maxLength) return;
  
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  if (value.length > maxLength) {
    input.value = value.substring(0, maxLength);
    input.dispatchEvent(new Event('input'));
  }
}

validateNumberInput(event: KeyboardEvent, rowData: any, field: string) {
  const inputChar = event.key;
  const currentValue: string = rowData[field] || '';
  
  if ([8, 9, 27, 13].includes(event.keyCode)) {
    return;
  }
  if (/\d/.test(inputChar)) {
    return;
  }

  if (inputChar === ',' || inputChar === '.') {
    if (!currentValue.includes(',') && !currentValue.includes('.')) {
      return;
    }
  }
  event.preventDefault();
}

openCreateSourcingProjectDialog(rowData: any) {
  this.sourcingProjectClick.emit(rowData);  
}
formatNumberInput(rowData: any, field: string) {
  if (!rowData[field]) return;
  
  const value = String(rowData[field]);
  
  let cleanedValue = value.replace(/[^\d,.]/g, '');
  
  if (cleanedValue.includes(',') && cleanedValue.includes('.')) {
    const firstSeparator = cleanedValue.match(/[,.]/)![0];
    cleanedValue = cleanedValue.replace(new RegExp(`[${firstSeparator === ',' ? '.' : ','}]`, 'g'), '');
  }
  
  rowData[field] = cleanedValue;
}

onStatusButtonClick(rowData: any) {
  console.log('Status button clicked for:', rowData);

}
  onHistoryLogoClick(rowIndex: number, field: string, rowData: any) {
    this.historyData.emit({ rowIndex, field, rowData })
  }


onHistoryClick(event: MouseEvent, rowData: any) {
  event.stopPropagation();
  this.historyClicked.emit(rowData);
}

  onPageChange(event: any) {
    this.pageChange.emit(event)
  }

  onDropdownChange(event: any, field: any, row: any) {
    this.tableDropdownChange.emit({ event, field, row })
  }


  onDecidedChange(row: any): void {
    this.calculateDecidedVolumes();
    const expectedKey = this.getExpectedDecidedKey(row);
    console.log('Expected key for', row.BRAND_NAME, ':', expectedKey);
  }

  onCopyOrder(row: any) {
    this.copyOrderClick.emit(row);
  }

calculateDecidedVolumes(): void {
  const sourceVolumeMap: { [sourceBrandCode: string]: number } = {};

  this.rows.forEach(row => {
    if (row.DECIDED && row.BRAND_VOLUME > 0) {
      sourceVolumeMap[row.DECIDED] = (sourceVolumeMap[row.DECIDED] || 0) + Number(row.BRAND_VOLUME || 0);
    }
  });

  this.rows.forEach(row => {
    row.DEC_SOURCE_VOLUME = sourceVolumeMap[row.BRAND_CODE] || 0;
  });
}
getExpectedDecidedKey(row: any): string {
    const group = row.GROUP_NAME;
    const brand = row.BRAND_NAME || row.BRAND; 

    switch (group) {
      case 'Europe':
        return brand.includes('Scania') ? 'EU-Scania' : 'EU-MAN';
      case 'Latin America':
        return brand.includes('Scania') ? 'LA-Scania' : 'LA-VW';
      case 'North America':
        return 'NA-International';
      case 'Asia':
        return 'Asia-Scania';
      default:
        return '';
    }
  }
getRowClass = (rowData: any) => {
  return this.selectionMode === 'single' ? 'no-row-highlight' : '';
};

  onSearchButtonClick(event: any, field: any, row: any) {
    this.tableSearchButtonClick.emit({ event, field, row })

  }

  deleteItem(rowData: any, field: string, itemIndex: number) {
    this.deleteTableItem.emit({ rowData, field, itemIndex })
  }
  onRadioSelect(field: string, rowData: any) {
    if (this.selectedRowForSingleSelection === rowData) {
      this.selectedRowForSingleSelection = null;
    } else {
      this.selectedRowForSingleSelection = rowData;
    }
    this.radioSelect.emit({ field, rowData: this.selectedRowForSingleSelection });
  }


  onInputChange(event: any, field: any, row: any) {
    this.tableInputChange.emit({ event, field, row })
  }

  onCheckboxChange(event: any, field: string, rowData: any) {
     if (this.separateRowAndCheckboxClick) {
      this.checkboxChange.emit({ field, rowData, event });
      return;
    }

    this.checkboxChange.emit({ field, rowData, event });
    
    if (event.checked) {
      this.selectedRow = rowData;
      this.rowSelect.emit({ event: event, row: rowData });
    } else {
      this.rowUnselect.emit({ event: event, row: rowData });
    }

    this.updateSelectAllState(); 
  }

onSelectAllChange(event: any): void {
  const checked = event.checked;
  this.selectAllChecked = checked;

  this.rows.forEach(row => {
    if (row.disabled || row.checkboxDisabled) return;
    if (row[this.checkboxField] === checked) return; 

    row[this.checkboxField] = checked;
    const syntheticEvent = { checked, originalEvent: event.originalEvent };
    this.checkboxChange.emit({ field: this.checkboxField, rowData: row, event: syntheticEvent });

    if (checked) {
      this.rowSelect.emit({ event: syntheticEvent, row });
    } else {
      this.rowUnselect.emit({ event: syntheticEvent, row });
    }
  });

  const selectedRows = this.rows.filter(row => row[this.checkboxField]);
  this.selectAllChange.emit({ checked, rows: selectedRows }); 
}
  private updateSelectAllState(): void {
    if (!this.rows?.length || !this.checkboxField) {
      this.selectAllChecked = false;
      return;
    }
    const selectableRows = this.rows.filter(row => !row.disabled && !row.checkboxDisabled);
    this.selectAllChecked = selectableRows.length > 0
      && selectableRows.every(row => row[this.checkboxField]);
  }

  onRowClick(event: MouseEvent, rowData: any) {
    if (this.separateRowAndCheckboxClick) {
      this.rowSelect.emit({
        event: {
          originalEvent: event,
          data: rowData
        },
        row: rowData
      });

      return;
    }

    if (this.selectionMode === 'multiple' && this.checkboxField) {
      const newValue = !rowData[this.checkboxField];
      rowData[this.checkboxField] = newValue;
  
      if (!Array.isArray(this.selectedRow)) {
        this.selectedRow = [];
      }
  
      if (newValue) {
        const alreadySelected = this.selectedRow.includes(rowData);
        if (!alreadySelected) {
          this.selectedRow = [...this.selectedRow, rowData];
          this.rowSelect.emit({ event: { checked: newValue }, row: rowData });
        }
      } else {
        this.selectedRow = this.selectedRow.filter((row: any) => row !== rowData);
        this.rowUnselect.emit({ event: { checked: newValue }, row: rowData });
      }
  
      this.checkboxChange.emit({
        field: this.checkboxField,
        rowData,
        event: { checked: newValue }
      });
    }
  }
  
  onDateChange(event: any, field: any, row: any) {
    this.tableDateChange.emit({ event, field, row })
  }


  handleBlur(event: any, field: any, row: any) {
    this.blurChange.emit({ event, field, row })
  }


  openEditDialog(rowData: any, item: string, rowIndex: number, field: string) {
    this.editMember.emit({ rowData, item, rowIndex, field });
  }

  onAddTeamMember(rowData: any, field: string, rowIndex: any): void {
    this.addTeamMember.emit({ rowData, field, rowIndex });

  }

  @Output() starToggled = new EventEmitter<any>();
  starStateMap: { [key: string]: boolean } = {};
  getStarKey(rowIndex: number, field: string): string {
    return `${rowIndex}-${field}`;
  }

  getStarClass(rowIndex: number, field: string, item: string): string {
    const key = `${rowIndex}-${field}-${item}`;
    return this.starStateMap[key] ? 'pi pi-star-fill text-yellow-500' : 'pi pi-star';
  }

  toggleStar(rowIndex: number, field: string, item: string, rowData: any): void {
    const key = `${rowIndex}-${field}-${item}`;
    const currentState = this.starStateMap[key];

    if (this.lockTable) {
      return;
    }

    Object.keys(this.starStateMap).forEach(starKey => {
      const [row] = starKey.split('-');
      if (+row === rowIndex) {
        this.starStateMap[starKey] = false;
      }
    });

    this.starStateMap[key] = !currentState;

    this.starToggled.emit({
      rowIndex: rowIndex,
      field: field,
      item: item,
      isStarred: this.starStateMap[key],
      rowData: rowData
    });
  }


  initializeStarStateFromInput(): void {
    if (this.starredState && this.starredState.length > 0) {
      this.starredState.forEach((starItem: { rowIndex: any; field: any; teamMember: any; }) => {
        const { rowIndex, field, teamMember } = starItem;
        const key = `${rowIndex}-${field}-${teamMember}`;
        this.starStateMap[key] = true;
      });
    }
  }

  getTextAlignmentClass(data: DataType) {
    switch (data) {
      case DataType.String:
        return "text-left";
        break;

      case DataType.Number:
        return "text-center";
        break;

      case DataType.Date:
        return "text-center";
        break;

      default:
        return "text-left";
        break;
    }
  }

  onDropdownChangeFilter(ev: any) {
    this.dropdownFilterChange.emit({ event: ev });
  }

  clear(table: Table) {
    table.clear();
  }
  sortOrder: number;
  getGlobalFilterFields(columns: any[]): string[] {
    return columns.map(col => col.field)
  }

  onRowSelect(event: any) {
    this.rowSelect.emit({ event: event, row: this.selectedRow });
    if(this.isInvoiceRadioButton){
      this.onRadioSelect("",event.data);
    }
  }

  onRowUnselect(event: any) {
    this.rowSelect.emit({ event: event, row: this.selectedRow });
    // Do not modify 
  }

  checkColumnType(columnType: any) {
    return columnType
  }

  onSortIconClick(field: string) {
    Object.keys(this.sortState).forEach(col => {
      if (col !== field) {
        this.sortState[col] = 0;
      }
    });
    if (!this.sortState[field] || this.sortState[field] === 0) {
      this.sortState[field] = 1; // ASC
    } else if (this.sortState[field] === 1) {
      this.sortState[field] = -1; // DESC
    } else {
      this.sortState[field] = 0; // No Sort
    }
    let orderText = '';
    if (this.sortState[field] === 1) {
      orderText = 'ASC';
    } else if (this.sortState[field] === -1) {
      orderText = 'DESC';
    } else {
      orderText = 'NONE';
    }
    this.sortStatus.emit({ field, order: orderText });
  }

  getSortIcon(field: string): string {
    const order = this.sortState[field] || 0;
    if (order === 1) {
      return 'pi pi-sort-amount-up-alt';  // ASC
    } else if (order === -1) {
      return 'pi pi-sort-amount-down-alt';  // DESC
    }
    return 'pi pi-sort-alt';  // No Sort
  }



}
